
import styles from './MembersIntro.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';
import { useLocation, useNavigate } from 'react-router-dom';
import CanvasJSReact from '@canvasjs/react-charts';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CanvasJSChart = CanvasJSReact.CanvasJSChart;


function MembersIntro() {


    const { pToast, useAlert, useModal, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState({});


    

    const fetchData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_document/out/get_detail`, { type: "yehs_intro" , idx : 0 , headCate : 11 } , {
                withCredentials: true
            });

            if (response.data.result === 't') {
                const data = response.data.data;
                setData(data)
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    }


    useEffect(() => {
        fetchData();
    }, []);



    const [chartOptions, setChartOptions] = useState(null); // 차트 옵션에 대한 상태 생성

    const fetchStatisticsData = async () => {
        try {
            pLoadingOn();
            const response = await axios.post(`${API_BASE_URL}/yehs_member/out/get_future_member`, {
                withCredentials: true
            });
    
            if (response.data.result === 't') {
                const data = response.data.data;
    
                // 서버에서 받아온 데이터를 기반으로 dataPoints 배열 업데이트
                const dataPoints = [
                    { name: "취업(직장생활)", y: parseInt(data[0].employment), color: "#B2DF8A" },
                    { name: "대학원생", y: parseInt(data[0].graduateStudent), color: "#1F78B4" },
                    { name: "대학생", y: parseInt(data[0].student), color: "#A6CEE3" }
                ];
    
                // 총합 계산
                const total = dataPoints.reduce((sum, data) => sum + data.y, 0);
    
                // 옵션 설정
                const options = {
                    animationEnabled: true,
                    subtitles: [{
                        verticalAlign: "center",
                        fontSize: 24,
                        dockInsidePlotArea: true
                    }],
                    data: [{
                        type: "doughnut",
                        showInLegend: true,
                        indexLabel: "{name}: {y}명 ({percentage}%)",
                        innerRadius: 50, // 가운데 구멍 크기를 조절
                        dataPoints: dataPoints.map(point => ({
                            ...point,
                            percentage: ((point.y / total) * 100).toFixed(1)
                        }))
                    }]
                };
    
                // 차트를 업데이트하거나 렌더링하는 로직 추가 (예: setState를 사용하는 경우)
                setChartOptions(options);
    
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Data fetching failed:', error);
        } finally {
            pLoadingOff();
        }
    };
    
    useEffect(() => {
        fetchStatisticsData();
    }, []);


    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageid = queryParams.get('pageid');

    const [activeTab, setActiveTab] = useState(1);
    useEffect(() => {
        if (pageid) {
            setActiveTab(Number(pageid));
        }
    }, [pageid]);

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        navigate(`?pageid=${tabIndex}`);
    };


    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>회원소개</span>

                <div className={styles.tab_box}>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 1 ? styles.active : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        YEHS 회원
                    </button>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 2 ? styles.active : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        YEHS Senior
                    </button>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 3 ? styles.active : ''}`}
                        onClick={() => handleTabClick(3)}
                    >
                        회원 통계
                    </button>
                </div>

                {activeTab === 1 && ( 
                    <>
                        <div
                        className='intro_wrap'
                        dangerouslySetInnerHTML={{ __html: data.contents }}></div>
                    </>
                )}
                {activeTab === 2 && ( 
                    <>
                        <div className={styles.intro_flex_wrap}>
                            <div className={styles.left_box}>
                                <span className={styles.intro_cont_2}>
                                    YEHS Senior는 한국공학한림원 산하의
                                    YEHS출신 젊은 과학기술인들의 연합 모입니다.<br />
                                    YEHS 출신의 대한민국 젊은이들이 국가 및 국제 사회에 기여하는 차세대 글로벌 과학기술 도전자들로 다같이 성장하기 위해 다시 뭉쳤습니다. YEHSenior는 사회 각 분야에서 과학기술을 바탕으로 더 나은 세상을 만들겠다는 꿈을 같이 꾸면서 활동하고 있는 한국공학한림원 산하의 YEHS 출신 젊은 과학기술인의 모임입니다.<br />

                                    과학기술은 사회의 변혁을 이끄는 핵심적인 동인입니다. 사회로 진출한 YEHS인들은 이/공학 교육을 배경으로, 사회의 다양한 변화를 이끄는 최전선에서 활발하게 활동하고 있습니다. 산업계에서 연구개발 인력으로, 기술경영 분야에서 경영인으로, 학계에서 대학원생 및 연구원으로, 공공 분야에서의 정책 인력으로, 그 외에도 사회 각 분야에서 변화와 혁신을 이끄는 도전자로 - YEHS인은 사회에 진출한 후에도 YEHSenior의 이름으로 모여 더 훌륭한 인재로 성장하여, 다같이 더 나은 세상을 만들기 위한 노력을 계속하려 합니다.<br />
                                    이를 위해 YEHSenior는 다양한 분야에서 활동하고 있는 YEHS인들 사이에 인간적인 교분을 나눌 수 있고 지식과 경험을 공유할 수 있는 교류의 장을 열어, YEHS인들이 앞으로 각계에서 대한민국과 세계를 이끄는 리더로 성장할 수 있는 지속적인 바탕을 마련하고자 합니다. 앞으로 YEHS, 그리고 YEHSenior가 같이 발전해나가는 모습을 관심을 가지고 지켜봐 주시기를 부탁합니다.<br />

                                    YEHSenior는 YEHS에서 진취적인 비전과 성실한 활동, 우수한 역량을 보인 젊은 공학도들 중에서 회원을 선발하고 있습니다. 저희와 같이 과학기술을 통해 더 나은 세상을 만들어가자는 꿈에 동참하고 싶으신 젊은 공학도들께서는 YEHS의 문을 두드려 주시기 바랍니다.
                                </span>
                            </div>
                            <div className={styles.right_box}>
                                <img src="/img/yehs_intro_2.jpg" alt="" />
                            </div>
                        </div>
                    </>
                )}
                {activeTab === 3 && ( 
                    <>
                        {chartOptions && <CanvasJSChart options={chartOptions} />}
                    </>
                )}
                
            </div>
        </>
    );
}

export default MembersIntro;